// 「パリィを1種類にする」(2026-10-09 ユーザー裁定「1種類にする」「120ms」・2026-10-10 配布版の既定にした)。
//   相談の材料 = docs/research/2026-10-09-just-normal-parry-unify.md の案1。
//
// 旧 (off):   押してから 80ms 以内 = ジャストパリィ / 80〜200ms = 普通のパリィ (量・光・音・止め・崩せるか・撃ち返しが別)。
// 既定 (a):   押してから 120ms 以内に受けた弾きは全部「旧のジャストパリィ」の扱い (効果・光・音・止め・崩し・撃ち返しがそのまま)。
//             120ms より早い押しは弾きにならない。押しっぱなしなら受付が終わった所から長押しガード (player.ts) が受け、離していたら当たる。
//             普通のパリィ (旧の 120〜200ms の扱い) は無い。
//   a = ボスへ 25・自分へ 6 (旧のジャストの量) / b = ボスへ 20・自分へ 8 (文書 §2-3 の bot で旧の平均と同じ手応えだった量・DEV ?parryOne=b だけ)。
//
// 変えない物: 受付が終わるまでの 1 回の長さ (空振りの硬直・弾いた後に動ける時刻) は旧と同じ。受付だけが 200ms → 120ms に縮む
//   (player.ts がサイクルの終わりに足りない分を足す)。連打の縮み (200→130→67) は、縮んだ値が 120 を下回る時だけ効く = 2回目の連打から。
//
// 配布版は常に a: setParryOneMode は DEV でしか効かず、main.ts の読み取りも DEV の箱の中 (scripts/check_dev_leak.mjs に parryOne・__parryOne を登録)。
//   DEV の ?parryOne=off (または 0) で旧へ戻して見比べられる。

import { PLAYER } from './balance'

export type ParryOneMode = 'off' | 'a' | 'b'

/** 1種類の弾きが受けられる幅 (押してからの ms)。ユーザー裁定 (10-09)「120ms」。 */
export const PARRY_ONE_WINDOW_MS = 120
/** b の量 (a = 旧のジャストの量 = balance.ts のまま)。 */
export const PARRY_ONE_B_GAIN = { boss: 20, self: 8 } as const

let mode: ParryOneMode = 'a'

/** URL の ?parryOne=。on / a / 1 = a、b = b、off / 0 = off (旧)。それ以外は null (呼び出し側が既定の a にする)。 */
export function parseParryOneMode(v: string | null | undefined): ParryOneMode | null {
  if (v === 'on' || v === 'a' || v === '1') return 'a'
  if (v === 'b') return 'b'
  if (v === 'off' || v === '0') return 'off'
  return null
}

export function setParryOneMode(m: ParryOneMode): void { if (import.meta.env.DEV) mode = m }
export function parryOneMode(): ParryOneMode { return import.meta.env.DEV ? mode : 'a' }
export function parryOneOn(): boolean { return parryOneMode() !== 'off' }

/** 一押しの「弾きの受付」の長さ (ms)。effective = 連打で縮んだ後の値 (player.parryActiveMsEffective)。off (旧) なら effective のまま。 */
export function parryOneCatchMs(effective: number): number {
  return parryOneOn() ? Math.min(effective, PARRY_ONE_WINDOW_MS) : effective
}

/** 受付を縮めた分、パリィ 1 回の長さが縮まないように足す時間 (ms)。off (旧) は 0。 */
export function parryOneTailMs(effectiveBeforeCap: number): number {
  return parryOneOn() ? Math.max(0, effectiveBeforeCap - parryOneCatchMs(effectiveBeforeCap)) : 0
}

/** b の間の「自分・ボスに溜まる量」。a と off は null (a は旧のジャストの量をそのまま使う)。 */
export function parryOneGains(): { boss: number; self: number } | null {
  return parryOneMode() === 'b' ? PARRY_ONE_B_GAIN : null
}

// 覚え書き: 旧のジャスト受付 (PLAYER.perfectParryWindowMs 80ms) は定数として残す。
//   致命の弾き (src/exec_parry.ts) は 2026-10-10 に配布版へ入れた時、受付を普段と同じ 120ms (stunParryCatchMs) にした。
//   この 80ms の定数は今どこからも使っていない (旧の「致命だけ狭く」案の名残・戻す時の目印)。
export const PARRY_ONE_EXEC_WINDOW_MS = PLAYER.perfectParryWindowMs
